export default [
    {
        path: '/scheduler/swimlane',
        name: 'Scheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Swimlane',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/transport/SchedulerIndex.vue'),
            agent: () => import('@views/scheduler/transport/SchedulerIndex.vue'),
        },
    },
    {
        path: '/scheduler/schedule/:id/edit',
        name: 'ScheduleEdit',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Schedule',
        },
        props: {
            default: (route) => ({ id: route.params.id }),
            agent: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/scheduler/transport/ScheduleEdit.vue'),
            agent: () => import('@views/scheduler/transport/ScheduleEdit.vue'),
        },
    },
];
